var _Array$isArray = require("core-js/library/fn/array/is-array.js");
function _arrayWithHoles(arr) {
  if (_Array$isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;